module.exports = __webpack_public_path__ + "img/games-19.9de6973c.jpg";